// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-11-07T15:16:47+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190344
//    Project:        617
//    Environment:    7626 - master
//    MD5:            84325e52f94b080105b784c79f3a976c
//    Signature:      eyJpdiI6ImdwanhzVGtTVFNGeXd4SytMQ0JKZEE9PSIsInZhbHVlIjoiK3psM01DMDdLcVJ1bXU2dVc5VW54NUxIVGVYZW1VZ1Mxa2NpdTZYS0x1NUlmZ0lKKzVsd0ExWlwvdlUwbDBhMHdNMEFmcFwvQXB5ZDdSekhEdU1KXC9JZ002RFhCUWFNYzJkdlBiNDk1TjUwa2I3NHozMCtTTW9tRlhmUWRIVXRFMmR0WithRkhBZVhsXC9rQVwvTStvcGx1T1wvTyt3NEQ3Qm0wT2ljcG1PcG1yTGNCc3ZncjZROERoWDBvZkxDM3BnNUd1UlJvZkhcL2RJbFM1OVU0d3htNWpIU3hDU3dOMGxtNU1raGlES2ZSVkZkRlh5T2dHd3FrdDNCbDVnUWF5Q08ybFl6VGZjYXZNdStIZFVhampWR0JlWEdqTDlSWWlvMXFEMFVqeitMQmpiZ1JLZmlsTCsydW9JWEJscENkVXNhMVwvamZ0d3pTTGc2Z1wvM1RYUit4bFJ2UnN4d3E0YXFTcjExdUpNUVwvVVNjVWJxVWFWMWZzRE54bGNNMUgrM3hUMUtONVFzS1FRXC9yZWJ5QkJMTlwvQ1JYMUg1Zz09IiwibWFjIjoiOWFhZGUyYTNmZDkyYjI3YWM0YWRlNDA1ZWJkOWJkYWUyYzAyOTMxZDY5MmNiOTk2ODJiOGRmOTU4NzA0NDYwZCJ9
class SizeGuideController extends HTMLElement {
  connectedCallback() {
    // Check if this is inside a modal or standalone
    const modal = this.closest('.product-popup-modal');
    const isModal = !!modal;
    
    if (isModal && modal.dataset.sizeGuideSetup === '1') return;

    const content = modal ? modal.querySelector('.product-popup-modal__content-info') : this.parentElement;
    if (!content) return;

    const sizingContainers = content.querySelectorAll('.Container.sizing');
    if (!sizingContainers.length) return;

    // Attach gender/unit interactions for each sizing container
    sizingContainers.forEach(container => {
      this.attachInteractions(container);
    });

    if (isModal) {
      modal.dataset.sizeGuideSetup = '1';
    }
  }

  attachInteractions(container) {
    const womenTab = container.querySelector('.clear-this .half[data-id="women-tab"]');
    const menTab = container.querySelector('.clear-this .half[data-id="men-tab"]');
    const womenSection = container.querySelector('.women');
    const menSection = container.querySelector('.men');

    // Toggle visble gender sections and active tab state
    const showGender = target => {
      if (!womenSection || !menSection) return;
      const showWomen = target === 'women';

      womenSection.style.display = showWomen ? '' : 'none';
      menSection.style.display = showWomen ? 'none' : '';

      if (womenTab) womenTab.classList.toggle('active', showWomen);
      if (menTab) menTab.classList.toggle('active', !showWomen);
  
    };

    // Switch the active unit (CM/INCH) within the current gender
    const activateUnit = (sectionRoot, unitId) => {
      if (!sectionRoot) return;

      const unitTabs = sectionRoot.querySelectorAll('.measurements');
      const unitPanels = sectionRoot.querySelectorAll('.measurement-contents');

      unitTabs.forEach(tab => tab.classList.remove('active'));
      unitPanels.forEach(panel => {
        panel.classList.remove('active');
        panel.style.display = 'none';
      });

      const targetTab = sectionRoot.querySelector(`.measurements[data-id="${unitId}"]`);
      const targetPanel = sectionRoot.querySelector(`.measurement-contents[data-id="${unitId}"]`);

      if (targetTab) targetTab.classList.add('active');
      if (targetPanel) {
        targetPanel.classList.add('active');
        targetPanel.style.display = '';
      }
    };

    // Bind gender tab clicks (Women/Men)
    container.querySelectorAll('.clear-this .half').forEach(tab => {
      tab.addEventListener('click', () => {
        const id = tab.getAttribute('data-id');
        if (id === 'women-tab') {
          showGender('women');
          activateUnit(womenSection, 'women-cm');
        } else if (id === 'men-tab') {
          showGender('men');
          activateUnit(menSection, 'men-cm');
        }
      });
    });

    [womenSection, menSection].forEach(sectionRoot => {
      if (!sectionRoot) return;
      sectionRoot.querySelectorAll('.measurements').forEach(button => {
        button.addEventListener('click', () => {
          const unitId = button.getAttribute('data-id');
          activateUnit(sectionRoot, unitId);
        });
      });
    });

    container.querySelectorAll('.measurement-contents').forEach(panel => {
      const shouldShow = panel.classList.contains('active');
      panel.style.display = shouldShow ? '' : 'none';
    });

    if (menSection && menTab && !menTab.classList.contains('active')) {
      menSection.style.display = 'none';
    }
  }
}

customElements.define('size-guide-controller', SizeGuideController);

// Watch for the product modal opening, then inject the controller
const observer = new MutationObserver(muts => {
  muts.forEach(m => {
    if (m.type === 'attributes' && m.attributeName === 'open' && m.target.classList && m.target.classList.contains('product-popup-modal')) {
      if (m.target.hasAttribute('open')) {
        const content = m.target.querySelector('.product-popup-modal__content-info');
        if (!content) return;
        if (!content.querySelector('size-guide-controller')) {
          const el = document.createElement('size-guide-controller');
          content.appendChild(el);
        }
      }
    }
  });
});

// Function to initialize size guides
function initializeSizeGuides() {
  // Initialize modal-based size guides
  document.querySelectorAll('.product-popup-modal').forEach(modal => {
    observer.observe(modal, { attributes: true });
  });
  
  // Initialize standalone size guides
  document.querySelectorAll('.Container.sizing').forEach(container => {
    if (!container.querySelector('size-guide-controller')) {
      const el = document.createElement('size-guide-controller');
      container.appendChild(el);
    }
  });
}

document.addEventListener('DOMContentLoaded', initializeSizeGuides);


